<template>
    <div class="all_custom_price" :style="styles">
        <template v-if="returnAllowShowPrice.show">
            <template v-if="type==='goods'">
                <div class="goods_box" :class="alignObj[align]">
                    <template v-if="returnGoodsType==='default'">
                        <div class="price_box">
                            <span :style="returnFontSize.main" class="price_text">{{ tip +'￥'+returnDefaultPrice().price }}</span>
                            <span :style="returnFontSize.sub" v-if="returnDefaultPrice().discount_price!=''">
                                ￥{{ returnDefaultPrice().discount_price }}
                            </span>
                        </div>
                        <p :style="returnFontSize.sub" class="coupon_price" v-if="returnDefaultPrice().coupon_price!=''">惠后约￥{{ returnDefaultPrice().coupon_price }}</p>
                    </template>
                    <template v-if="returnGoodsType==='wholesale'">
                        <div class="price_box">
                            <span :style="returnFontSize.main" class="price_text">{{ tip + returnWholesalePrice().price }}</span>
                            <span :style="returnFontSize.sub" v-if="returnWholesalePrice().underlinePrice!=''">{{ returnWholesalePrice().underlinePrice }}</span>
                        </div>
                        <!-- <p :style="returnFontSize.sub" class="coupon_price" v-if="returnWholesalePrice().coupon_price!=''">惠后约￥{{ returnWholesalePrice().coupon_price }}</p> -->
                    </template>
                    <template v-if="returnGoodsType==='bundling'">
                        <div class="bundling_price_box">
                            <p :style="returnFontSize.main" class="price_text">￥{{ returnBundlingPrice().discountPrice }}</p>
                            <p :style="returnFontSize.sub" v-if="returnBundlingPrice().price!=''">优惠前：￥{{ returnBundlingPrice().price }}</p>
                            <p :style="returnFontSize.sub" v-if="returnBundlingPrice().num!=''">套餐数量：{{ returnBundlingPrice().num }}</p>
                        </div>
                    </template>
                    <template v-if="returnGoodsType!='default'&&returnGoodsType!='wholesale'&&returnGoodsType!='bundling'">
                        <div class="price_box">
                            <span :style="returnFontSize.main" class="price_text">{{ tip +'￥'+returnDiscountPrice().price }}</span>
                            <span :style="returnFontSize.sub" v-if="returnDiscountPrice().discount_price!=''">
                                ￥{{ returnDiscountPrice().discount_price }}
                            </span>
                        </div>
                        <p :style="returnFontSize.sub" class="coupon_price" v-if="returnDiscountPrice().coupon_price!=''">惠后约￥{{ returnDiscountPrice().coupon_price }}</p>
                    </template>
                    <div class="market_box" v-if="returnMarketPrice.show">
                        <span :style="returnFontSize.sub" class="coupon_price">建议零售价：￥{{ returnMarketPrice.price }}</span>
                    </div>
                </div>
            </template>
            <template v-if="type==='order'"></template>
        </template>
        <template v-else>
            <div :class="alignObj[align]">
                <span class="redText">￥{{ returnAllowShowPrice.text }}</span>
            </div>
        </template>
       
        <!-- 原价 -->
        <!-- 折扣价 -->
        <!-- 优惠价 -->
        <!-- 阶梯范围价 -->
        
<!-- 换行 -->
        <!-- 建议零售价 -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
    export default {
        props: {
            // 样式相关配置
            size:{
                type:String,
                default:''
            },
            color:{
                type:String,
                default:''
            },
            styles:{
                type:String,
                default:''
            },
            align:{
                type:String,
                default:'left'          // center 居中(centerText)  left 左对齐  right 右对齐
            },
            // 数据相关配置
            type:{
                type:String,
                default:'goods'    // goods 商品  order 订单
            },
            // 商品类型指定   组合套餐没有数据可以进行判断，只能通过外部传入进行判断
            goodsType:{
                type:String,
                default:''    // default 默认计算  bundling 捆绑计算
            },
            info:{
                type:Object,
                default:()=>{
                    return {}
                }
            },
            // 金额的前置提示词
            tip:{
                type:String,
                default:''
            }
        },
        data(){
            return {
                price:'',
                discount_price:'',
                coupon_price:'',
                alignObj:{
                    center:'centerText',
                    left:'',
                    right:''
                }
            }
        },
        computed:{
            ...mapGetters(["token"]),
            returnGoodsType() {
                let type = 'default';
                if((this.info.is_getfree != undefined && this.info.is_getfree)||(this.info.get_free_goods != undefined && this.info.get_free_goods != null && JSON.stringify(this.info.get_free_goods) != '{}')){
                    // 换购
                    type = 'getfree';
                }
                if(this.info.promotion_label === 'seckill'){
                    // 秒杀
                    type = 'seckill';
                }
                if(this.info.promotion_label === 'discount'){
                    // 折扣
                    type ='discount';			
                }
                if(this.info.promotion_label === 'wholesale'||(this.info.wholesale_goods_id!=undefined&&this.info.wholesale_goods_id!=null&&this.info.wholesale_goods_id>=0)){
                    // 阶梯
                    type ='wholesale';			
                }
                if(this.goodsType==='bundling'){
                    // 组合套餐
                    type = 'bundling';
                }
                return type;
            },
            returnMarketPrice(){
                let obj = {
                    show:false,
                    price:''
                };
                if(this.info.market_price!=undefined && parseFloat(this.info.market_price)>0){
                    obj.show = true;
                    obj.price = this.info.market_price;
                }
                if(this.returnGoodsType==='default'){
                    if(parseFloat(obj.price)==parseFloat(this.returnDefaultPrice().price)){
                        obj.show = false;
                    }
                }
                if(this.returnGoodsType==='wholesale'){
                    if(parseFloat(obj.price)==parseFloat(this.returnWholesalePrice().price)){
                        obj.show = false;   
                    }
                }
                if(this.returnGoodsType==='bundling'){
                    if(parseFloat(obj.price)==parseFloat(this.returnBundlingPrice().discountPrice)){
                        obj.show = false;   
                    }
                }
                if(this.returnGoodsType!='default'&&this.returnGoodsType!='wholesale'&&this.returnGoodsType!='bundling'){
                    if(parseFloat(obj.price)==parseFloat(this.returnDiscountPrice().price)){
                        obj.show = false;   
                    }
                }
                return obj;
            },
            returnAllowShowPrice(){
                let obj = {
                    show:false,
                    text:''
                };
                if(this.token){
                    if(this.info.sale_control!==undefined){
                        let linObj = this.info.sale_control;
                        if(linObj.is_member_by&&linObj.view_price){
                            obj.show = true;
                        }else{
                            obj.text = (linObj.not_buy_msg!=''?linObj.not_buy_msg:'暂无权限');
                        }
                    }else{
                        obj.show = true;
                    }
                }else{
                    obj.text = '登录可见';
                }
                return obj;
            },
            returnFontSize(){
                let defaultSize = 16;
                let obj = {
                    main:`font-size:${defaultSize}px;line-height: ${defaultSize+2}px;`,
                    sub:`font-size:${defaultSize-2}px;line-height: ${defaultSize}px;`
                }
                if(this.size!==''){
                    let num = parseFloat(this.size);
                    obj.main = `font-size:${num}px;line-height: ${num+2}px;`;
                    obj.sub = `font-size:${num-2}px;line-height: ${num}px;`;
                }
                return obj;
            }
        },
        mounted(){

        },
        methods:{
            returnDefaultPrice(){
                let obj = {
                    price:'',
                    discount_price:'',
                    coupon_price:''
                };
                if(this.info.price!=undefined){
                    obj.price = this.info.price;
                }
                if(this.info.discount_price!=undefined&&parseFloat(this.info.discount_price)!=parseFloat(this.info.price)){
                    obj.price = this.info.discount_price;
                    obj.discount_price = this.info.price;
                }
                if(this.info.coupon_price!=undefined&&parseFloat(this.info.coupon_price)>0&&parseFloat(this.info.coupon_price)!=parseFloat(obj.price)){
                    obj.coupon_price = this.info.coupon_price;
                }
                return obj;
            },
            returnDiscountPrice(){
                let obj = {
                    price:'',
                    discount_price:'',
                    coupon_price:''
                };
                if(this.info.price!=undefined){
                    obj.price = this.info.price;
                }
                if(this.info.discount_price!=undefined&&parseFloat(this.info.discount_price)!=parseFloat(this.info.price)){
                    obj.price = this.info.discount_price;
                    obj.discount_price = this.info.price;
                }
                let boo11 = (this.info.join_coupon!=undefined&&this.info.join_coupon!=null&&this.info.join_coupon>0)||(this.info.join_coupon==undefined);
                let boo12 = (this.info.coupon_price!=undefined&&parseFloat(this.info.coupon_price)>0&&parseFloat(this.info.coupon_price)!=parseFloat(obj.price));
                if(boo11&&boo12){
                    obj.coupon_price = this.info.coupon_price;
                }
                return obj;
            },
            returnWholesalePrice(){
                let obj = {
                    price:'',
                    underlinePrice:'',
                    coupon_price:''
                };
                let str = '';
                if(this.info.price!=undefined){
                    obj.price = ('￥'+this.info.price);
                    str = ('￥'+this.info.price);
                }
                let wholesaleInfo = (this.info.promotion_info?this.info.promotion_info:this.info);
                if(wholesaleInfo.min_price!=undefined&&wholesaleInfo.min_price!=null&&parseFloat(wholesaleInfo.min_price)>0){
                    obj.price = ('￥'+wholesaleInfo.min_price);
                    if(wholesaleInfo.max_price!=undefined&&wholesaleInfo.max_price!=null&&parseFloat(wholesaleInfo.max_price)>0&&parseFloat(wholesaleInfo.max_price)>parseFloat(wholesaleInfo.min_price)){
                        obj.price = (obj.price+' ~ ￥'+wholesaleInfo.max_price);
                    }
                }
                if(obj.price!=str){
                    obj.underlinePrice = str;
                }
                if(this.info.coupon_price!=undefined&&parseFloat(this.info.coupon_price)>0&&parseFloat(this.info.coupon_price)!=parseFloat(obj.price)){
                    obj.coupon_price = this.info.coupon_price;
                }
                return obj;
            },
            returnBundlingPrice(){
                let obj = {
                    price:'', // 优惠前
                    num:'', // 套餐数量
                    discountPrice:'' // 优惠后
                };
                obj.discountPrice = this.info.promotion_price;
                if(obj.discountPrice!=this.info.price){
                    obj.price = this.info.price;
                }
                obj.num = this.info.num;
                return obj;
            }
        },
        watch:{
            
        },
    }
</script>

<style lang="scss" scoped>
.all_custom_price{
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .redText{
        color: red !important;
    }
    .price_text{
        color: #ff547b;
        font-weight: bold;
    }
    .centerText{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .goods_box{
        display: flex;
        flex-direction: column;
        gap: 4px;
        .market_box{
            display: flex;
            align-items: center;
        }
        .coupon_price{
            display: flex;
            align-items: center;   
            color: green;
        }
    }
    .price_box{
        display: flex;
        align-items: baseline;
        gap: 4px;
        >span:nth-child(2){
            color: #999;
            text-decoration: line-through;
        }
    }
    .bundling_price_box{
        display: flex;
        flex-direction: column;
        gap: 4px;
        >p:not(:first-child){
            color: #FB7100;
        }
    }
}
</style>